module.exports = __webpack_public_path__ + "img/intro.9ee8e373.jpg";